// ── Stitch redirect handler ──
//
// The app has no router; like /join/{code} and ?headoffice it inspects window.location
// on load. After the user consents on Stitch's hosted flow, Stitch redirects back to
// STITCH_REDIRECT_URI (…/bankfeed/callback) with ?code=…&state=…. This module detects
// that, exchanges the code for a linkId, hands it back via onLinked(), and cleans the
// URL so a refresh can't replay the exchange. Dormant-safe: returns false immediately
// when the feature is off or there's no pending link.

import { isBankFeedEnabled } from "./config";
import { exchangeCode } from "./stitchClient";

export async function handleStitchRedirect({ onLinked } = {}) {
  if (!isBankFeedEnabled()) return false;

  let params;
  try { params = new URLSearchParams(window.location.search || ""); } catch (e) { return false; }
  const code = params.get("code");
  if (!code) return false;

  // Only treat this as our redirect if we're on the callback path OR we have a pending
  // PKCE verifier (set just before we redirected to Stitch) — avoids hijacking unrelated
  // ?code= params.
  const path = window.location.pathname || "";
  let hasVerifier = false;
  try { hasVerifier = !!sessionStorage.getItem("stitch_pkce_verifier"); } catch (e) {}
  if (!path.startsWith("/bankfeed/callback") && !hasVerifier) return false;

  // The account we were linking for (and whether it's a project or stokvel) was stashed
  // before the redirect; state mirrors the id.
  let linkTargetId = null;
  let parent = "projects";
  try {
    linkTargetId = sessionStorage.getItem("stitch_link_project") || params.get("state") || null;
    parent = sessionStorage.getItem("stitch_link_parent") || "projects";
  } catch (e) {
    linkTargetId = params.get("state") || null;
  }

  try {
    const err = params.get("error");
    if (err) {
      const desc = params.get("error_description");
      throw new Error("Stitch link error: " + err + (desc ? " — " + desc : ""));
    }
    const linkId = await exchangeCode(code);
    try { sessionStorage.removeItem("stitch_link_project"); sessionStorage.removeItem("stitch_link_parent"); } catch (e) {}
    if (onLinked) await onLinked({ linkId, projectId: linkTargetId, parent });
  } catch (e) {
    if (onLinked) await onLinked({ error: e, projectId: linkTargetId, parent });
  }

  // Strip code/state/error from the URL.
  try { window.history.replaceState({}, document.title, window.location.origin + "/"); } catch (e) {}
  return true;
}
